/**
 * Маппінг backend сутностей (з permissions) на frontend ресурси
 * Одна backend сутність може відповідати декільком frontend ресурсам
 */
export const ResourceCorrespondenceConfig = {
    List: [
        'Setting.ListCancellationReason',
        'Setting.ListCargo',
        'Setting.ListCarrier',
        'Setting.ListCluster',
        'Setting.ListClusterResponsible',
        'Setting.ListConstructionObject',
        'Setting.ListCurrency',
        'Setting.ListCurrencyRate',
        'Setting.ListExpenseCategory',
        'Setting.ListExpenseItem',
        'Setting.ListIncomeCategory',
        'Setting.ListIncomeItem',
        'Setting.ListLoadingPoint',
        'Setting.ListObjectType',
        'Setting.ListPeriod',
        'Setting.ListPosition',
        'Setting.ListProductionObject',
        'Setting.ListProjectCategory',
        'Setting.ListProjectDirection',
        'Setting.ListProjectSubcategory',
        'Setting.ListRegion',
        'Setting.ListTechOperation',
        'Setting.ListVehicleKind',
        'Setting.ListVehicleType',
    ],
    Vehicle: 'Transport.Vehicle',
    Route: 'Transport.TypicalRoute',
    TransportRequest: 'Request.Request',
    ExecutorAssignment: 'Assignment.Assignment',
    Shift: 'Shift.Shift',
    ExchangeQueue: 'Setting.ErpExchange',
    CurrencyRate: 'Setting.ListCurrencyRate',
    Currency: 'Setting.ListCurrency',
    Locale: '?',
    Option: '?',
    SystemEvent: 'Setting.SystemEvents',
    TenantOption: '?',
    Tenant: '?',
    UserFavorite: '?',
    UserNotification: '?',
    UserOption: '?',
    UserPhotoFile: '?',
    User: 'Setting.User',
    Department: 'Setting.Department',
    ManualToken: 'Setting.ManualToken',
}

// Кешований обернений маппінг
let cachedRevertedConfig: Record<string, string> | null = null

/**
 * Реверсний маппінг: frontend ресурс -> backend сутність
 * Використовується CheckGlobalResourceAccessTask для перевірки доступів
 */
export const RevertResourceCorrespondenceConfig = (() => {
    if (cachedRevertedConfig) {
        return cachedRevertedConfig
    }

    const reverted: Record<string, string> = {}

    for (const [key, value] of Object.entries(ResourceCorrespondenceConfig)) {
        // Пропускаємо елементи зі значенням "?"
        if (value === '?') {
            continue
        }

        // Обробка масиву (наприклад List)
        if (Array.isArray(value)) {
            for (const item of value) {
                reverted[item] = key
            }
        } else {
            // Звичайне значення
            reverted[value] = key
        }
    }

    cachedRevertedConfig = reverted
    return reverted
})()
